(() => {
  if (window.JFLMenuInteractions) return;
  window.JFLMenuInteractions = true;

  const CLOSE_DELAY = 220;

  const installCloseDelay = () => {
    const Navigation = customElements.get('desktop-navigation');
    if (!Navigation || Navigation.prototype.JFLMenuCloseDelay) return;
    const prototype = Navigation.prototype;
    const nativeOpen = prototype.openDropdown;
    const nativeClose = prototype.closeDropdown;

    prototype.JFLMenuCloseDelay = true;
    prototype.openDropdown = function(parentElement) {
      this.jflCloseTimers ||= new Map();
      for (const [pendingParent, timer] of this.jflCloseTimers) {
        window.clearTimeout(timer);
        this.jflCloseTimers.delete(pendingParent);
        if (pendingParent !== parentElement) nativeClose.call(this, pendingParent);
      }
      return nativeOpen.call(this, parentElement);
    };
    prototype.closeDropdown = function(parentElement) {
      this.jflCloseTimers ||= new Map();
      window.clearTimeout(this.jflCloseTimers.get(parentElement));
      const timer = window.setTimeout(() => {
        this.jflCloseTimers.delete(parentElement);
        nativeClose.call(this, parentElement);
      }, CLOSE_DELAY);
      this.jflCloseTimers.set(parentElement, timer);
    };
  };

  customElements.get('desktop-navigation') ? installCloseDelay() : customElements.whenDefined('desktop-navigation').then(installCloseDelay);

  const setHeaderState = () => {
    document.querySelectorAll('store-header.header').forEach((header) => {
      const openMenu = header.querySelector('.jfl-mega-menu:not([hidden])');
      if (openMenu) openMenu.querySelectorAll('img[loading="lazy"]').forEach((image) => { image.loading = 'eager'; });
      header.classList.toggle('jfl-menu-active', Boolean(openMenu));
    });
  };

  const activateTab = (menu, tab, focus = false) => {
    if (!tab || tab.getAttribute('aria-selected') === 'true') return;
    menu.querySelectorAll('[data-jfl-menu-tab]').forEach((item) => {
      const selected = item === tab;
      item.setAttribute('aria-selected', String(selected));
      item.tabIndex = selected ? 0 : -1;
    });
    menu.querySelectorAll('.jfl-mega-menu__panel').forEach((panel) => { panel.hidden = panel.id !== tab.getAttribute('aria-controls'); });
    if (focus) tab.focus();
  };

  const closeKeyboardMenu = (trigger, menu) => {
    menu.hidden = true;
    trigger.setAttribute('aria-expanded', 'false');
    setHeaderState();
  };

  const initMenu = (menu) => {
    if (menu.dataset.jflReady === 'true') return;
    menu.dataset.jflReady = 'true';
    const tabs = Array.from(menu.querySelectorAll('[data-jfl-menu-tab]'));
    tabs.forEach((tab, index) => {
      tab.addEventListener('mouseenter', () => activateTab(menu, tab));
      tab.addEventListener('focus', () => activateTab(menu, tab));
      tab.addEventListener('click', () => activateTab(menu, tab));
      tab.addEventListener('keydown', (event) => {
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        let next = index;
        if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
        if (event.key === 'ArrowLeft') next = (index - 1 + tabs.length) % tabs.length;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = tabs.length - 1;
        activateTab(menu, tabs[next], true);
      });
    });

    const trigger = document.querySelector('[aria-controls="' + menu.id + '"]');
    const parent = trigger?.closest('.header__linklist-item');
    if (!trigger || !parent) return;
    trigger.addEventListener('keydown', (event) => {
      if (!['Enter', ' ', 'ArrowDown'].includes(event.key)) return;
      event.preventDefault();
      menu.hidden = false;
      trigger.setAttribute('aria-expanded', 'true');
      setHeaderState();
      (tabs[0] || menu.querySelector('a'))?.focus();
    });
    parent.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      event.preventDefault();
      closeKeyboardMenu(trigger, menu);
      trigger.focus();
    });
    parent.addEventListener('focusout', () => {
      window.setTimeout(() => { if (!parent.contains(document.activeElement)) closeKeyboardMenu(trigger, menu); }, 120);
    });
    new MutationObserver(setHeaderState).observe(menu, { attributes: true, attributeFilter: ['hidden'] });
  };

  const init = () => {
    document.querySelectorAll('[data-jfl-mega-menu]').forEach(initMenu);
    setHeaderState();
  };
  document.addEventListener('desktop-nav:dropdown:open', setHeaderState);
  document.addEventListener('desktop-nav:dropdown:close', () => window.setTimeout(setHeaderState, CLOSE_DELAY + 20));
  document.addEventListener('shopify:section:load', init);
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', init, { once: true }) : init();
})();
